export const constSystemFeature = {
    LOAD_SYSTEM_FEATURE: 'LOAD_SYSTEM_FEATURE',
    FETCH_TURNSTILE_SETTINGS: 'FETCH_TURNSTILE_SETTINGS',
    CLEAR_SITE_KEY: 'CLEAR_SITE_KEY',
    RESET_SITE_KEY: 'RESET_SITE_KEY',
};
